export default __webpack_public_path__ + "static/8-a12063ef3851310bb650192d5c6f6c65.jpg";